import { useEffect, useState } from 'react';
// Subscribes a component to a preference created by createPreference.
export default function usePreference(pref) {
  const [value, setValue] = useState(pref.resolve);
  useEffect(() => {
    const onChange = (e) => setValue(e?.detail ?? pref.resolve());
    window.addEventListener(pref.EVENT, onChange);
    return () => window.removeEventListener(pref.EVENT, onChange);
  }, [pref]);
  return [value, pref.set];
}
